module.exports = __webpack_public_path__ + "img/WhatsApp_Logo_3.bd938796.png";